import { css } from "@emotion/react";

export const indexWrapCss = css`
    padding: 0 0;
    margin: 0 auto;
    display: flex;
    background-color: white;
    flex-direction: column;
    overflow-x: hidden;
`;
export const mainMobileTextCss = css`
    display: flex;
    width: 100%;
    min-width: 320px;
    padding: 60px 16px 60px 16px;
    flex-direction: column;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;

    @keyframes fadeUp {
        0% {
            opacity: 0;
            transform: translateY(-20px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* 문단별 애니메이션 */
    .subText,
    .subText2,
    .mainText {
        opacity: 0;
        animation: fadeUp 0.8s ease-out forwards;
    }

    .subText {
        animation-delay: 0.3s;
    }

    .subText2 {
        animation-delay: 1.2s;
       
    }

    .mainText {
        animation-delay: 2.1s;
    }

    .subText,
    .subText2,
    .mainText {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
    }

    .subText span {
        font-size: 20px;
        font-weight: 500;
        color: #000000;
    }

    .subText2 p {
        color: #838383;
        font-size: 14px;
        font-weight: 400;
        margin: 0;
        line-height: 22px;
    }

    .mainText p {
        font-weight: 400;
        font-size: 16px;
        color: #000;
    }
`;





export const mainTextCss = css`
    display: flex;
    min-width: 1200px;
    padding: 120px 0px;
    flex-direction: column;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    gap: 12px;



    @keyframes fadeUp {
         0% {
             opacity: 0;
             transform: translateY(20px);
         }
         100% {
             opacity: 1;
             transform: translateY(0);
         }
     }
 
     .subText,
     .subText2,
     .mainText {
         opacity: 0;
         animation: fadeUp 0.8s ease-out forwards;
     }
 
     .subText {
         animation-delay: 0.2s;
         
     }
 
     .subText2 {
         animation-delay: 1s;
     }
 
     .mainText {
         animation-delay: 1.8s;
     }
 
    .subText p {
        color: #000000;
        font-size: 38px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }


    .subText2 p {
        color: #808080;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: 48px;
        padding: 0;
    }

    .subText,
    .subText2 {
        justify-content: flex-start;
        flex-direction: column;
        display: flex;
        width: 100%;
        align-items: center;     
        text-align: center;
    }

    .mainText {
        display: flex;
        width: 100%;
        align-items: center;
        text-align: center;
    }

    span {
        color: #000;
        text-align: center;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    @media (min-width: 1920px) {
        .mainText {
            justify-content: center;
            align-items: center;
            display: flex;
            width: 100%;
        }

        span {
            font-size: 24px;
        }
    }

    @media (min-width: 381px) and (max-width: 1919px) {
        width: 100%;
        max-width: 1200px;
        justify-content: center;
        margin: 0 auto;

        .mainText {
            justify-content: center;
            align-items: center;
            display: flex;
            width: 100%;
        }

        span {
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
    }

    @media (max-width: 380px) {
        display: flex;
        width: 100%;
        min-width: 0;
        flex-direction: column;
        align-items: flex-start;
        gap: 40px;
        padding: 60px 16px;
        margin: 0;
        box-sizing: border-box;

        p {
            color: #434343;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }

        .subText,
        .subText2 {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
            align-self: stretch;
        }

        .mainText {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 8px;
            align-self: stretch;
        }

        span {
            color: #000;
            text-align: left;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%;
        }
    }        }
    }
`;



export const newAuthorCss = css`
    display: flex;
    padding: 90px 336px;
   /* max-width: 1200px;*/
    margin: 0 auto;
    width: 100%;
    flex-direction: column; 
    gap: 8px;
    position: relative;
    align-self: stretch;
    box-sizing: border-box;
    
    .MainNewAuthorBackground {
        position: absolute; 
        top: 0;
        right: 0;
        height: 100%;
        z-index: 0; 
    }


    .MainNewAuthorBackgroundLeft {
        position: absolute;
        bottom: 0;
        left: 0;
        height: auto; 
        z-index: 0;
        transform: translateY(0%);
    }


    .newAuthorWrap {
        display: flex;
        padding: 0px 20px;
        flex-direction: column; 
        width:100%;
        max-width: 1200px;
        gap: 8px;
        align-self: stretch;
        z-index: 1;
        box-sizing: border-box;
    }

   @media (min-width: 1920px) {
        .newAuthorWrap {
            align-items: flex-start;
            display: flex;
            padding: 0px 20px;
            flex-direction: column;
            margin: 0 auto;
            width:100%;
            min-width: 1200px;
            gap: 8px;
            align-self: stretch;
            z-index: 1;
        }
    }


    span {
        color: #000;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: 50px;
    }

    .area {
        display: flex;
        flex-direction: row; 
        justify-content: center;
        align-items: center;
        gap: 40px;
        margin-top:40px;
        align-self: stretch;
        /*flex-wrap: wrap;*/

        
    }

    .authorContent {
        display: flex;
        width: 570px;
        height: 274px;
        padding: 13px 50px;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        gap: 32px;
        flex-shrink: 0;
        border-radius: 10px;
        background: #FFF;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s ease;


        img {
            border-radius : 150px;
            height: 100px;
            width : 100px;
        }
        
    }

    .authorContent:hover {
        transform: scale(1.05); 
    }

    
    .profile {
        display: flex;
        width: 100px;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        flex-shrink: 0;
    }

    .name {
        color: #000;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }


    .divide {
        width: 1px;
        height: 230.5px;
        background: #000;
        opacity: 0.1;
    }


    .authorText {
        display: flex;
        width: 286px;
        max-width: 100%;
        padding: 40px 0px;
        justify-content: flex-start;
        align-items: flex-start;
        flex-shrink: 0;
    }

    .authorText span {
        color: #000;
        font-family: "SeoulNamsanM";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
        opacity: 0.6;
        width: 100%;
        flex-shrink: 0;
    }
    
    
    @media (max-width: 1200px) {
        padding: 60px 20px;
        
        .newAuthorWrap {
            display: flex;
            width:100%;
            flex-direction: column;
            gap: 26px;
            padding: 0px;
            justify-content: center;
            align-items: center;
            align-self: stretch;
        }

        .area {
            flex-wrap: wrap;
            margin-top: 10px;
            justify-content: center;
            gap: 24px;
        }

        span {
            color: #000;
            font-size: 22px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%; 
        }

        .name {
            color: #000;
            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        

        .authorContent {
            display: flex;
            width: 100%;
            max-width: 420px;
            height: auto;
            min-height: 167px;
            padding: 12px 16px;
            justify-content: center;
            gap: 16px;
            flex-shrink: 1;
            box-sizing: border-box;

            img {
                border-radius : 75px;
                height: 75px;
                width : 75px;
            }
            
        }

        .MainNewAuthorBackground {
            display: none;
        }

        .MainNewAuthorBackgroundLeft {
            display: none;
        }


        .profile {
            display: flex;
            width: 80px;
            flex-direction: column;
            align-items: center;
            gap: 12px;
            flex-shrink: 0;
        }

        .divide {
            width: 1px;
            height: 120px;
        }
        
        .authorText {
            display: flex;
            padding: 10px 0px;
            justify-content: flex-start;
            align-items: center;
            flex: 1 1 0;
            align-self: stretch;
            width: auto;
            max-width: 100%;
            min-width: 0;
        }
        
        .authorText span {
            color: #000;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; 
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            word-break: break-all;
            flex-shrink: 1;
            width: 100%;
        }
        
    }

    @media (max-width: 380px) {
        padding: 40px 16px;

        .newAuthorWrap {
            flex-wrap: nowrap;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            padding: 0;
        }
        
        span {
            color: #000;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 140%;
            text-align: center;
        }

        .area {
            flex-wrap: wrap;
            margin-top: 10px;
            width: 100%;
            gap: 16px;
        }

        .authorContent {
            display: flex;
            width: 100%;
            height: auto;
            min-height: 130px;
            padding: 12px;
            align-items: center;
            gap: 12px;
            flex-shrink: 0;
            box-sizing: border-box;

            img {
                border-radius : 60px;
                height: 60px;
                width: 60px;
            }
        }

        .MainNewAuthorBackground {
            display: none;
        }

        .MainNewAuthorBackgroundLeft {
            display: none;
        }
        
        .profile {
            display: flex;
            width: 70px;
            flex-direction: column;
            align-items: center;
            gap: 8px;
            flex-shrink: 0;
        }

        .name {
            color: #000;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            word-break: break-all;
        }

        .divide {
            width: 1px;
            height: 90px;
        }

        .authorText {
            display: flex;
            padding: 4px 0px;
            justify-content: flex-start;
            align-items: center;
            flex: 1 1 0;
            align-self: stretch;
            width: auto;
            min-width: 0;
        }

        .authorText span {
            color: #000;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            word-break: break-all;
            opacity: 0.6;
            flex-shrink: 1;
            width: 100%;
        }
     
    }
 
    
`;

export const AddNewAuthorCss = css`
    display: flex;
    min-height: 200px;
    height: 381px;
    @media (max-width: 640px) {
        height: auto;
    }
    padding: 50px 20px;
    @media (min-width: 1910px) {
        padding: 50px 463px;
    }
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    align-self: stretch;
    background: linear-gradient(135deg, #E0FBEF 0%, #A1F2CB 100%);
    position: relative;
    overflow: hidden;
    box-sizing: border-box;

    @keyframes floating {
        0% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
        100% { transform: translateY(0px); }
    }

    .floating-char {
        animation: floating 3s ease-in-out infinite;
    }

    .premium-button {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 15px -3px rgba(25, 207, 122, 0.2), 0 4px 6px -2px rgba(25, 207, 122, 0.1);
            background-color: #F8FFF9;
        }
        &:active {
            transform: translateY(0px);
        }
    }

    @media (max-width: 380px) {
        padding: 40px 16px;
        width: 100%;
        gap: 20px;
    }
    
    
    
  
`;

export const AuthorListCss = css`
    display: flex;
    width: 100%;
    min-width: 1200px;
    margin: 0 auto;
    height: 1400px;
    padding: 120px 0px;
    flex-direction: column;
    align-items: center;
    position: relative;
    gap: 60px;
    

    .authorListBackgroud {
        position: absolute;
        top: 250px;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0; 
    }
    
    .authorList {
        margin-top : 60px;
        display: flex;
        justify-content: center;
        flex-direction: row;
        z-index: 1;
        gap: 28px;
    }
    
    .author {
        display: flex;
        width: 278px;
        height: 340px;
        padding: 30px 78px;
        align-items: center;
        flex-direction: column;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
        background-color: white;
        border-radius: 10px;
    }

`;

export const ScrollCss = css`
    
    ::-webkit-scrollbar {
        height: 8px;
    }
    ::-webkit-scrollbar-track {
        background: #f8f8f8;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #19cf7a; /* 원하는 색상 */
        border-radius: 4px;
    }

`;
